import React from 'react';
import toast from "react-hot-toast";

import styles from './ModalDiscount.module.scss';
import defaultDiscount from '../../constants/images/discount.png';
import {resolveMediaUrl} from "../../configs/urls";

const ModalDiscount = ({closeModal, selectedPromotion = {}}) => {
    const {title, description, image, promo_code} = selectedPromotion;

    const handleCopyCode = (e) => {
        e.stopPropagation();
        if (!promo_code) return;

        navigator.clipboard?.writeText(promo_code)
            .then(() => toast.success(`Промокод ${promo_code} скопійовано!`, {id: "copy-promo"}))
            .catch(() => toast.error("Не вдалось скопіювати промокод", {id: "copy-promo"}));
    };

    return (
        <div
            onClick={closeModal}
            className={styles.modalDiscount_wrapper}
        >
            <div
                className={styles.modalDiscount_wrapper_content}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalDiscount_wrapper_content_photo}>
                    <img src={resolveMediaUrl(image) || defaultDiscount} alt={title || 'promotion'}/>
                </div>

                <div className={styles.modalDiscount_wrapper_content_description}>
                    <h2 className={styles.title}>{title}</h2>
                    {description && <p className={styles.description}>{description}</p>}
                </div>

                {promo_code &&
                    <button
                        className={styles.modalDiscount_wrapper_content_button}
                        onClick={handleCopyCode}
                    >
                        Скопіювати Код
                    </button>}
            </div>
        </div>
    );
};

export default ModalDiscount;
